import React, { useState, useEffect, useRef } from "react";
import * as AiIcons from "react-icons/ai";
import * as FaIcons from "react-icons/fa";
import * as BsIcons from "react-icons/bs";
import * as SiIcons from "react-icons/si";
import { Link } from "react-scroll";
import { useNavigate } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import "../Styles.css";
import { useTheme } from "components/Hooks/darkmode";
import * as FiIcons from "react-icons/fi";

const img: string = require("../../assets/bg3.jpg");

const NavBar = () => {
  const [navBar, setNavBar] = useState(false);
  const { theme, setTheme } = useTheme();
  function handleToggleTheme() {
    setTheme(!theme);
  }

  const nav = useNavigate();

  const changeBg = () => {
    if (window.scrollY >= 80) {
      setNavBar(true);
    } else {
      setNavBar(false);
    }
  };
  window.addEventListener("scroll", changeBg);

  const ref = useRef(null);

  // useEffect(() => {
  //   const el2 = ref.current;

  //   let calcScrollValue = () => {
  //     let scrollProgress: any = document.getElementById("progress");
  //     let pos = document.documentElement.scrollTop;
  //     let calcHeight =
  //       document.documentElement.scrollHeight -
  //       document.documentElement.clientHeight;
  //     let scrollValue = Math.round((pos * 100) / calcHeight);
  //     if (pos > 80) {
  //       scrollProgress.style.display = "grid";
  //     } else {
  //       scrollProgress.style.display = "none";
  //     }
  //     scrollProgress.addEventListener("click", () => {
  //       document.documentElement.scrollTop = 0;
  //     });
  //     scrollProgress.style.background = `conic-gradient(#1F618D ${scrollValue}%, #d7d7d700 ${scrollValue}%)`;
  //   };
  //   window.onscroll = calcScrollValue;
  //   window.onload = calcScrollValue;
  // }, []);

  // const cursor: any = document.querySelector(".cursors");
  // document.addEventListener("mousemove", (e) => {
  //   cursor.style.left = e.pageX + "px";
  //   cursor.style.top = e.pageY + "px";
  // });

  const token = JSON.parse(
    localStorage.getItem("userCredentials") || "{}"
  )?.accessToken;

  return (
    <>
      <div>
        <div
          className={`${
            navBar
              ? "fixed top-0 left-0 right-0 bg-blend-difference bg-white shadow-md dark:shadow-slate-900 shadow-slate-500 dark:bg-[#092c44] ease-in duration-300 transition-all"
              : ""
          } flex items-center z-50 justify-between px-5 w-[100%] text-black dark:text-white`}
        >
          <ul className={`flex items-center home nav-menu`}>
            {/* <li
              className="mx-5 xl:mx-0 hover:text-[#009dff]  border-b-[#009dff] py-1 px-2  cursor-pointer nav-item"
              onClick={() => nav(!token ? "admin-login" : "dashboard")}
            >
              {" "}
              <FaIcons.FaUserAlt />
            </li> */}
            <li className="mx-5 xl:mx-0 hover:text-[#009dff]  border-b-[#009dff] py-1 px-2  cursor-pointer nav-item">
              <Link
                to="section_1"
                spy={true}
                smooth={true}
                offset={-100}
                duration={1000}
              >
                Home
              </Link>
            </li>
            <li className="mx-5 xl:mx-0 hover:text-[#009dff]  border-b-[#009dff] py-1 px-2  cursor-pointer nav-item">
              <Link
                to="section_3"
                spy={true}
                smooth={true}
                offset={0}
                duration={1000}
              >
                About
              </Link>
            </li>
            <li className="mx-5 xl:mx-0 hover:text-[#009dff]  border-b-[#009dff] py-1 px-2  cursor-pointer nav-item">
              <Link
                to="section_5"
                spy={true}
                smooth={true}
                offset={0}
                duration={1000}
              >
                Skills
              </Link>
            </li>
            <li className="mx-5 xl:mx-0 hover:text-[#009dff]  border-b-[#009dff] py-1 px-2  cursor-pointer nav-item">
              <Link
                to="section_7"
                spy={true}
                smooth={true}
                offset={0}
                duration={1000}
              >
                Projects
              </Link>
            </li>
            {/* <li className="mx-5 xl:mx-0 hover:text-[#009dff]  border-b-[#009dff] py-1 px-2  cursor-pointer nav-item">
              <Link
                to="section_9"
                spy={true}
                smooth={true}
                offset={0}
                duration={1000}
              >
                Blog
              </Link>
            </li> */}
            <li className="mx-5 xl:mx-0 hover:text-[#009dff]  border-b-[#009dff] py-1 px-2  cursor-pointer nav-item">
              <Link
                to="section_11"
                spy={true}
                smooth={true}
                offset={0}
                duration={1000}
              >
                Contact
              </Link>
            </li>
          </ul>
          <div>
            <span
              className="mx-5 xl:mx-0 hover:text-[#009dff]  border-b-[#009dff] py-1 px-2  cursor-pointer "
              onClick={handleToggleTheme}
            >
              {!theme ? (
                <FiIcons.FiSun className="transition-all" />
              ) : (
                <BsIcons.BsFillMoonFill className="transition-all" />
              )}
            </span>
          </div>
          <div className={`flex items-center text-2xl `}>
            {" "}
            <Tooltip title="Linkedin" arrow>
              <a
                href="https://www.linkedin.com/in/gerard-valentin-rutayisire-manzi-b79631234/"
                target="_blank"
                className="grow"
              >
                <FaIcons.FaLinkedin
                  className={`mx-2 cursor-pointer text-[#009dff]`}
                />
              </a>
            </Tooltip>{" "}
            <Tooltip title="Github" arrow>
              <a
                href="https://github.com/gerard1001"
                target="_blank"
                className="grow"
              >
                <FaIcons.FaGithub
                  className={`mx-2 cursor-pointer text-[#009dff]`}
                />
              </a>
            </Tooltip>
            <Tooltip title="Discord" arrow>
              <a
                href="https://discord.com/users/1071075450710933616"
                target="_blank"
                className="grow"
              >
                <SiIcons.SiDiscord
                  className={`mx-2 cursor-pointer text-[#009dff]`}
                />
              </a>
            </Tooltip>
            <Tooltip title="Telegram" arrow>
              <a
                href="https://t.me/gerard_manzi"
                target="_blank"
                className="grow"
              >
                <FaIcons.FaTelegramPlane
                  className={`mx-2 cursor-pointer text-[#009dff]`}
                />
              </a>
            </Tooltip>
          </div>
        </div>
      </div>
    </>
  );
};

export default NavBar;

// bg-[#9B59B6]
